import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 ma-8",
    staticStyle: {
      "background": "white",
      "border-radius": "6px"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c(VIcon, {
    staticClass: "icon",
    attrs: {
      "color": "#888",
      "size": "64"
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _c('h1', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.errorboundary.title')))]), _c('div', {
    staticClass: "message"
  }, [_vm.shouldUseSentry ? _c('p', [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.errorboundary.message')) + "\n      ")]) : _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getMessageText())
    }
  })]), _vm.shouldUseSentry ? _c('div', {
    staticClass: "actions"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-redo"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.errorboundary.tryAgain')) + "\n      ")]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-backward",
      "href": "/"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.errorboundary.backHome')) + "\n      ")])], 1) : _c('div', {
    staticClass: "actions"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-redo"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.errorboundary.tryAgain')) + "\n      ")]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-paper-plane",
      "href": _vm.getMailToLink()
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.errorboundary.contactUs')) + "\n      ")])], 1), _vm.showDetails ? _c('p', {
    staticClass: "details",
    on: {
      "click": _vm.showDetails
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.errorboundary.showDetails')))]) : _vm._e(), !_vm.showDetails ? _c('p', {
    staticClass: "details",
    on: {
      "click": _vm.showDetails
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.errorboundary.hideDetails')))]) : _vm._e(), _vm.showErrorDetails ? _c('pre', {
    staticClass: "red-text"
  }, [_vm._v("      " + _vm._s(_vm.error.stack) + "\n\n      found in \"" + _vm._s(_vm.info) + "\"\" in component \"" + _vm._s(_vm.element) + "\"\n    ")]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };